import MessageIcon from '@ordr-as/icons/MessageIcon';
import { Button } from '@ordr-as/umami-react/button';
import { useState } from 'react';
import { useCartIsClosing } from '../../../../hooks/useCartIsBusy';
import CheckoutCommentDialog from './CheckoutCommentDialog';

const NoteButton = () => {
  const [openCommentDialog, setOpenCommentDialog] = useState(false);

  const cartIsClosing = useCartIsClosing();

  return (
    <>
      <Button
        isDisabled={cartIsClosing}
        onClick={() => setOpenCommentDialog(true)}
        height={32}
        className=" text-small text-nowrap rounded-full p-4"
        kind="secondary"
        size="small"
      >
        <MessageIcon className="text-brand-black mr-2" />
        <span>Kitchen note</span>
      </Button>
      <CheckoutCommentDialog isOpen={openCommentDialog} setOpenCommentDialog={setOpenCommentDialog} />
    </>
  );
};

export default NoteButton;
